import { GuidToString, StringHash, UUID } from "@pdfking/tfunc"

import type { RemoteFile } from "../types/files/cached/RemoteFile"

import { ContentType } from "../types/files/ContentType"
import { VirtualFileType } from "../types/files/VirtualFileType"
import { PathContentType } from "./PathContentType"

export const CreateRemoteFile = async ({
  file_meta,
  guid,
  mirrors,
  type,
}: Partial<RemoteFile>): Promise<RemoteFile> => ({
  enum: VirtualFileType.REMOTE_FILE,
  file_meta: file_meta || {},
  guid:
    guid ??
    GuidToString(
      mirrors && mirrors.length > 0 ? await StringHash(mirrors) : UUID()
    ),
  mirrors: mirrors ?? [],
  type: type ?? PathContentType(mirrors || []) ?? ContentType.PDF,
})
